import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useState } from 'preact/hooks'
import { api } from '../api/client'
import type { ImportReport } from '../api/generated/ImportReport'
import type { VolunteerImport } from '../api/generated/VolunteerImport'
import { useAction } from '../api/useAction'
import { PhoneField } from '../phone/PhoneField'
import { importErrors } from './rows'

const inputValue = (e: Event) => (e.target as HTMLInputElement).value

/** Adds one volunteer without a shift: an import of a single row, which invites them. */
export function AddVolunteerDialog({ slug, onClose }: { slug: string; onClose: () => void }) {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [issue, setIssue] = useState<string>()
  const { error, pending, run } = useAction()
  const submit = (e: Event) => {
    e.preventDefault()
    setIssue(undefined)
    run(async () => {
      const body: VolunteerImport = {
        rows: [{ name, email, phone, shift_ids: [] }],
        dry_run: false,
      }
      const report = await api.post<ImportReport>(`/events/${slug}/volunteers/import`, body)
      const rejected = report.errors[0]
      if (rejected) setIssue(importErrors[rejected.error])
      else onClose()
    })
  }
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={submit}>
        <DialogTitle>Ajouter un bénévole</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Son compte est créé s'il n'existe pas. Il reçoit par email un lien pour indiquer ses
              disponibilités et les postes qui l'intéressent. Vous l'affecterez ensuite à des
              créneaux.
            </Typography>
            <TextField
              label="Prénom et nom"
              autoFocus
              value={name}
              onInput={(e) => setName(inputValue(e))}
            />
            <TextField
              label="Email"
              type="email"
              required
              value={email}
              onInput={(e) => setEmail(inputValue(e))}
            />
            <PhoneField
              label="Téléphone (facultatif)"
              helperText="Visible des organisateurs, pour l'appeler"
              value={phone}
              onValue={setPhone}
            />
            {(issue ?? error) && <Alert severity="error">{issue ?? error}</Alert>}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Annuler</Button>
          <Button type="submit" variant="contained" loading={pending}>
            Ajouter
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
